// actions
export const SETTINGS_LOAD_PREFERENCES = 'Load preferences'
export const SETTINGS_UPDATE_PREFERENCE = 'Update preference'

// mutations
export const SETTINGS_BULK_SET_PREFERENCES = 'Bulk set preferences'
export const SETTINGS_SET_PREFERENCE = 'Set preference'
